import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";

interface mutateProps { id: string, data: FieldValues }

const mutateUpdateSafetyChecklist = async ({ id, data }: mutateProps) => {
  return await axiosAuth.put(`${SAFETY_CHECKLIST_API}/${id}`, data);
};

const useUpdateSafetyChecklistMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateSafetyChecklist,
    ...queryParams,
  });

export default useUpdateSafetyChecklistMutation;
